export const TASK_STATUSES = {
  OPEN: 'open',
  OVERDUE: 'overdue',
  RESOLVED: 'resolved',
};
